import CheckinsReport from './CheckinsReport.container';

export default CheckinsReport;
